export default "__VITE_ASSET__cc96ef52__"